import { Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { DataService } from '../data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent  {
  loginDisplay = false;
  displayedColumns: string[] = ['claim', 'value'];
  dataSource: any =[];
  loginForm: FormGroup;
  showPassword: boolean = false;

  constructor(private router: Router, private fb: FormBuilder, private data: DataService, private messageService: MessageService) { 
    this.loginForm = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
      Clave: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  // ngOnInit(): void {
  //   this.msalBroadcastService.msalSubject$
  //     .pipe(
  //       filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
  //     )
  //     .subscribe((result: EventMessage) => {
  //       console.log(result);
  //       const payload = result.payload as AuthenticationResult;
  //       this.data.Token= payload.idToken;
  //       this.authService.instance.setActiveAccount(payload.account);
  //     });

  //   this.msalBroadcastService.inProgress$
  //     .pipe(
  //       filter((status: InteractionStatus) => status === InteractionStatus.None)
  //     )
  //     .subscribe(() => {
  //       this.setLoginDisplay();
  //       this.getClaims(this.authService.instance.getActiveAccount()?.idTokenClaims as Record<string, any>);
  //     })

  // }

    // Método para manejar el envío del formulario
   async onSubmit() {
      if (this.loginForm.valid) {
        console.log('Formulario enviado:', this.loginForm.value);
        //ejecutar data.Login(this.loginForm)
        var token = await this.data.Login(this.loginForm.value).toPromise();
        //guardar el token como variable de sesion      
        if (token) {
          this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Usuario autenticado'});
          //configurar el token en la variable de sesion llamada "token"
          sessionStorage.setItem('token', token.toString());
          //this.data.checkLoginStatus();
          this.data.cambiarEstadoUsuario();
          this.loginDisplay = true;
          this.data.loginDisplay = true;
          //redirigir a la pagina 'formularios'
          this.router.navigate(['/formularios']);
        } else {
          console.log('Formulario no válido');
          this.messageService.add({severity:'error', summary: 'Error', detail: 'Credenciales incorrectas. Inténtelo nuevamente.'});
        }
      } else {
        console.log('Formulario no válido');
      }
    }

      // Getter para los controles del formulario
  get controls() {
    return this.loginForm.controls;
  }

  // setLoginDisplay() {
  //   this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  // }

  // getClaims(claims: Record<string, any>) {
  //   if (claims) {
  //     Object.entries(claims).forEach((claim: [string, unknown], index: number) => {
  //       this.dataSource.push({id: index, claim: claim[0], value: claim[1]});
  //       this.data.Claims= this.dataSource;
  //     });
      
  //   }
  // }

}